/* system_note.icon.svg.js */

module.exports = require("./system.icon.svg");
